import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';

import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { Constante } from '../../../constante';
import { ResponseLocal } from '../../../core/models/response-local';
import { iDialogoConfirm } from '../../../core/models/dialogos';

@Component({
    selector: 'app-confirmation-dialog',
    imports: [CommonModule, MatDialogModule, MatDividerModule, MatSlideToggleModule, MatButtonModule, MatIconModule, FormsModule, ReactiveFormsModule],

    templateUrl: './confirmation-dialog.html',
    styleUrl: './confirmation-dialog.scss'
})
export class ConfirmationDialog {
    _const = Constante;
    showTitle: boolean = false;
    title: string = "";
    message: string = "";
    detail: string = "";
    showDetail: boolean = false;
    textOk: string = "ACEPTAR";
    textCancel: string = "CANCELAR";


    dialogResult: ResponseLocal<any> = {
        status: this._const.DIALOG_STATUS_CANCEL,
        data: null
    };

    constructor(
        public dialogRef: MatDialogRef<ConfirmationDialog>,
        @Inject(MAT_DIALOG_DATA) public data: iDialogoConfirm
    ) {
        //console.log(data)
        this.showTitle = data.showTitle ? data.showTitle : false;
        this.title = data.title ? data.title : "";
        this.message = data.message;
        this.showDetail = data.detail ? true : false;
        this.detail = data.detail ? data.detail : "";
        this.textOk = data.textOk ? data.textOk : "ACEPTAR";
        this.textCancel = data.textCancel ? data.textCancel : "CANCELAR";
    }


    onOk() {
        this.dialogResult.status = this._const.DIALOG_STATUS_OK;
        this.dialogRef.close(this.dialogResult);
    }

    ngOnDestroy() {
        this.dialogRef.close(this.dialogResult);
    }

}
